import Vue from "vue";
import i18n from "@/i18ns/i18n";
import { MSEnum } from "@/commons/enumeration";
import i18nEnum from "@/i18ns/vi/i18nEnum";
import store from "@/stores/store";
import { ModuleContext } from "@/stores/module-const";
import _ from "lodash";
import moment from "moment";
import httpClient from "@/apis/base/axios-httpclient";

/**
 * Class chứa các function dùng chung cho hệ thống phía client
 */
class CommonFunction {
  /**
   * Lấy config cho xác thực
   * @param {string} idType - Loại ID xác thực (JETPAYID hoặc MISAID_V2)
   */
  async getAuthConfig(idType) {
    // Nếu là MISAID_V2, sử dụng key cache riêng
    const key = idType === "MISAID_V2" ? "MisaAuthConfig" : "AuthConfig";
    const cacheConfig = this.getLocalStorage(key);
    if (cacheConfig) {
      return JSON.parse(cacheConfig);
    }

    let url = [window._apis.Auth, "/api/account/config"].join("");

    // Chỉ thêm tham số provider=MISAID nếu idType là MISAID_V2
    let requestConfig = { url: url };
    if (idType === "MISAID_V2") {
      requestConfig.params = { provider: "MISAID_V2" }; // Giữ nguyên provider=MISAID vì backend đang mong đợi giá trị này
    }

    let res = await httpClient.getAsync(requestConfig);

    if (res && !res.error) {
      this.setLocalStorage(key, JSON.stringify(res));
    }
    return res;
  }

  getMainLoading() {
    let el = document.body.querySelector("#mloading");
    return el;
  }
  mask() {
    let el = this.getMainLoading();
    if (el) {
      el.style.display = "flex";
    }
  }
  maskContent(content) {
    let el = document.body.querySelector("#mloading2");
    document.body.querySelector(".loading-text").innerHTML = content;
    if (el) {
      el.style.display = "flex";
    }
  }
  unmask() {
    let el = this.getMainLoading();
    if (el) {
      el.style.display = "none";
    }
  }
  unmaskContent() {
    let el = document.body.querySelector("#mloading2");
    if (el) {
      el.style.display = "none";
    }
  }
  infoLogging() {}
  errorLogging() {}
  handleException(error) {
    console.error(error);
  }

  /**
   * Xử lý hiển thị dialog
   * @author DNThang - 30.10.2019
   * DNThang - 06.05.2020: Trong trường hợp owner là popup thì sẽ append vào content để không bị chìm ở dưới
   */
  prepareForDialog(component, owner, options) {
    var me = this;
    if (owner && component) {
      var frmType = Vue.extend(component),
        frm = new frmType(options);

      frm.$mount();

      if (owner.isMsPopup) {
        let contentElement = owner.$refs.popupx; //owner.$el.querySelector('.ms-popup-content.ms-popup');
        contentElement.appendChild(frm.$el);
      } else {
        if (owner instanceof Element) {
          owner.appendChild(frm.$el);
        } else {
          owner.$el.appendChild(frm.$el);
        }
      }

      return frm;
    }

    return;
  }
  /**
   * Build vue key cho data
   */
  genVKeyValue(data, field = "__vKeyValue") {
    if (data) {
      data.forEach((item) => {
        item[field] = this.generateUUID();
      });
    }
  }
  /**
   *  Tạo uuid
   *  Create by: pvduong1 - 30/08/2019
   */
  generateUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      let d = new Date().getTime();
      d += performance.now();
      let r = ((d + Math.random() * 16) % 16) | 0;
      d = Math.floor(d / 16);
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  /**
   * Guild empty
   */
  generateEmptyUUID() {
    return "00000000-0000-0000-0000-000000000000";
  }
  /**
   * Kiểm tra 2 đối tượng có phải là cha con của nhau không
   */
  hasParent(child, parent) {
    if (child.parentElement) {
      if (child.parentElement === parent) {
        return true;
      } else {
        return this.hasParent(child.parentElement, parent);
      }
    }

    return false;
  }

  /**
   * Xử lý render element động
   */
  renderDynamicElement(target, component, owner, options) {
    var me = this;
    if (owner && component) {
      var frmType = Vue.extend(component),
        frm = new frmType(options);

      frm.$mount();

      //target.appendChild(frm.$el);
      return frm;
    }
  }

  /**
   * focus vào control tiếp theo
   */
  focusNextControl(curfocus) {
    var el = this.getNextInputControl(curfocus);
    if (el) {
      el.focus();
      if (typeof el.select === "function") {
        el.select();
      }

      return true;
    }
  }

  /**
   * Kiểm tra element có hiển thị không
   */
  isVisible(element) {
    return element.offsetParent;
  }

  /*
   * Lấy control nhập liệu tiếp theo
   */
  getNextInputControl(current) {
    let me = this,
      //i = c.index(),
      p = current.parentNode;
    if (!p) {
      return null;
    }

    let ch = p.children,
      r = null,
      o,
      i = 0;
    for (; i < ch.length; i++) {
      if (ch[i] === current) {
        break;
      }
    }

    for (var k = i + 1; k < ch.length; k++) {
      o = ch[k];
      if (
        ["INPUT", "TEXTARE", "BUTTON", "A"].indexOf(o.tagName) > -1 &&
        !o.getAttribute("disabled") &&
        !o.getAttribute("tabindex") !== -1 &&
        me.isVisible(o)
      ) {
        r = o;
      } else {
        r = me.getFirstControlFocus(o);
      }

      if (r) {
        break;
      }
    }

    if (!r) {
      r = me.getNextInputControl(p);
    }

    return r;
  }
  /**
   * Lấy control nhập liệu đầu tiên
   */
  getFirstControlFocus(parent) {
    const me = this,
      obj = parent || document,
      selector = [
        'input:not([disabled]):not([tabindex="-1"])',
        'textarea:not([disabled]):not([tabindex="-1"])',
        'select:not([disabled]):not([tabindex="-1"])',
        'button:not([disabled]):not([tabindex="-1"]):not(.ms-con-dropdown)',
        'a:not([disabled]):not([tabindex="-1"]):not(.ms-collapse-item--header)',
      ].join(",");

    const items = obj.querySelectorAll(selector);
    if (items != null && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (me.isVisible(item)) {
          return item;
        }
      }
    }

    return null;
  }

  /**
   * Tìm ra control Input đầu tiên theo scope truyền vào và cho phép sửa
   * @param {Element} scope Parent cần tìm input
   */
  findFirstControlInput(scope) {
    if (scope && scope.querySelector) {
      var input = scope.querySelector(
        "input:not([type=button]):not([type=radio]):not([type=checkbox]):not([readonly]):not([disabled]),textarea:not([readonly]):not([disabled])",
      );
      return input;
    }
    return;
  }

  /**
   * Tự động focus vào control nhập liệu đầu tiên theo scope truyền vào
   * @param {Element} scope Phạm vi cần xử lý focus
   * @author DNThang - 31.10.2019
   */
  focusFirstControlInput(scope, select = true) {
    var me = this;

    // setTimeout(() => {
    var input = me.findFirstControlInput(scope);
    if (input) {
      input.focus();

      if (select && typeof input.select === "function") {
        input.select();
      }
    }
    // });
  }

  /**
   * Tự động focus vào control nhập liệu đầu tiên theo scope truyền vào
   * @param {Element} scope Phạm vi cần xử lý focus
   * @author bnduc - 15.11.2019
   */
  focusFirstControl(scope) {
    if (scope) {
      const me = this;

      // setTimeout(() => {
      let input;
      if (
        scope.type === "text" ||
        (scope.hasAttribute && scope.hasAttribute("type") && scope.getAttribute("type") === "text")
      ) {
        input = scope;
      } else {
        input = me.findFirstControlFocus(scope);
      }

      if (input) {
        input.focus();
      }
      // });
    }
  }

  /**
   * Lấy ra vị trí ký tự hoặc số đầu tiên trong đoạn
   * @param {*} letter
   * @returns
   */
  indexFirstAlphabeticaLetter(letter) {
    let index = letter.match(
      /[0-9a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/i,
    ).index;
    return index;
  }

  /**
   * Tìm ra control Input đầu tiên theo scope truyền vào và cho phép sửa
   * @param {Element} scope Parent cần tìm input
   * @author bnduc - 15.11.2019
   */
  findFirstControlFocus(scope) {
    if (scope && scope.querySelector) {
      let input = scope.querySelector(
        "input:not([readonly]):not([disabled]),button:not([disable]),a,textarea",
      );
      return input;
    }
    return;
  }

  /**
   * Xử lý khi focus control cuối cùng thì sẽ thực thi fn
   */
  processUnfocusLastControl(e, fn) {
    if (e.which === 9 && !e.shiftKey) {
      //console.log(e.target.attributes.class.value);
      let cur = e.target;
      let els = e.currentTarget.querySelectorAll("*");
      var flag = true;
      for (let i = 0; i < els.length; i++) {
        if (els[i] === cur) {
          flag = false;
          continue;
        }
        if (flag) {
          continue;
        }

        els[i].focus();
        if (els[i] === document.activeElement) {
          e.preventDefault();
          return;
        }
      }

      //focus first control
      e.preventDefault();
      fn();
    }
  }

  /**
   * Kiểm tra 2 đôi tượng có khác nhau không
   */
  checkDiff(newVal, oldVal) {
    let ret = false;
    if (typeof newVal == "object" && typeof oldVal == "object") {
      for (let field in newVal) {
        if (typeof newVal[field] != "object" && newVal[field] != oldVal[field]) {
          ret = true;
          break;
        }
      }
    }
    return ret;
  }

  //Chuyển dữ liệu thành dạng tree
  // Created by LTDAT(16.06.2020)
  nomalizeDataTree(data, idField, parentField) {
    const me = this;
    let dataTemp = [...data],
      parentNodes = [];
    dataTemp.forEach((item, index) => {
      if (!item.hasOwnProperty("parentNode")) {
        item["parentNode"] = [];
      }
      if (item[parentField]) {
        //Tìm cha
        let parent = _.find(dataTemp, (o) => {
          return o[idField] === item[parentField];
        });

        if (parent) {
          item.parentNode = parent;
          if (!parent.hasOwnProperty("childNodes")) {
            parent["childNodes"] = [];
          }
          if (!parent.hasOwnProperty("isParent")) {
            parent["isParent"] = true;
          }
          parent.childNodes.push(item);
        } else {
          parentNodes.push(item);
        }
      } else {
        // NMSINH: thêm món này vì nếu chọn thằng ko có Cha trong list thì nó chính là cha luôn
        parentNodes.push(item);
      }
    });
    return parentNodes;
  }

  /**
   * Thực hiện ghép các node cha đi kèm với các node con luôn để thực hiện show ra ngay bên dưới node cha
   * @param {[TreeModel]} dataResoures Danh sách các node cha cần sắp xếp
   * @param {*} expanded Có Mở rộng ra không
   * @param {*} level
   */
  getBodyData(dataResoures, expanded, level = 1, childNodes = "childNodes") {
    if (!dataResoures) {
      return [];
    }
    let data = [...dataResoures];
    let bodyData = [];
    data.forEach((row, index) => {
      const children = row[childNodes];
      const childrenLen =
        Object.prototype.toString.call(children).slice(8, -1) === "Array" ? children.length : 0;

      row.level = level;
      Vue.set(row, "isHide", false);
      Vue.set(row, "expanded", expanded);
      // row.expanded = expanded;
      row.isSelected = false;
      row._isSelectedMultiple = false;

      bodyData.push(row);
      if (childrenLen > 0) {
        row._expandable = true;
        bodyData = bodyData.concat(this.getBodyData(children, expanded, level + 1));
      }
    });

    return bodyData;
  }

  /**
   * Lấy giá trị enum theo text
   */
  getEnumValue(enumName, text) {
    let source = this.getEnumSource(enumName);
    let textTrim = text.trim();
    for (let i = 0; i < source.length; i++) {
      let item = source[i];
      if (textTrim === item.enumText) {
        return item.enumValue;
      }
    }

    return null;
  }

  /**
   * Lấy ra giá trị key của enum theo value
   * @param {Number} value Giá trị của enum cần lấy ra enum text
   * @param {String} enumName EnumName để get text
   */
  getEnumText(value, enumName) {
    let e = MSEnum[enumName],
      localize = i18n;

    if (e) {
      for (const key in e) {
        if (e.hasOwnProperty(key) && e[key] === value) {
          return key;
        }
      }
    }

    return value;
  }

  /**
   * Lấy ra resource theo enum
   * @param {Number} value Giá trị của enum cần lấy ra enum resource
   * @param {String} enumName EnumName để get text
   */
  getEnumResource(value, enumName) {
    const me = this,
      localize = i18n;

    let key = me.getEnumText(value, enumName);
    let resourceKey = enumName + "." + key;
    let text = i18n.global.t("i18nEnum." + resourceKey);
    return text;
  }

  /**
   * Kiểm tra merchant có tất cả các role danh mục
   */
  isMerchantFullRoleCategory(value, enumName) {
    const me = this;
    let lstRoleMerchant = i18nEnum.RoleCategoryMerchant;
    let merchantType = -1;
    let currentMerchant = JSON.parse(me.getLocalStorage("CurrentMerchant"));
    if (currentMerchant) {
      merchantType = currentMerchant.merchantType;
    }
    // List role category when ignore MerchantAdmin and PaymentLink (merchantType is school)
    let arryIgnore = _.values(lstRoleMerchant).filter(function (result) {
      let paymentLink =
        merchantType === MSEnum.MerchantType.School ? lstRoleMerchant.Paymentlink : null;
      return result != lstRoleMerchant.MerchantAdmin && result != paymentLink;
    });
    let lstRole = localStorage.getItem("RoleLocal");
    let isFullRoleCategory = arryIgnore.every((element) => {
      return lstRole.includes(element);
    });
    return isFullRoleCategory;
  }

  /**
   * Lấy enumsource với tên enum truyền vào
   * @param {String} enumName Tên enum trong enumeration
   * @param {Array} values Danh sách các enum lấy ra (nếu cần chỉ định), nếu không thì sẽ lấy tất cả
   * @param {Boolean} prefixIdx Có kèm theo tiền tố index không: true - có, false - không (Mặc định không)
   * VD: getEnumSource("EnumCABAReasonType",[10,11,12,13])
   * CreatedBy: PDKIEN 15/08/2019
   */
  getEnumSource(enumName, values, prefixIdx) {
    let e = MSEnum[enumName],
      arr = [],
      localize = i18n;
    if (e) {
      let idx = 0;
      for (const key in e) {
        if (e.hasOwnProperty(key)) {
          let v = e[key],
            ix = -1;
          if (!values || (ix = values.indexOf(v)) > -1) {
            /*
             * sửa lại cách lấy dữ liệu theo enum
             * pvduy 02/02/2020
             */
            let enumText = i18n.global.t("i18nEnum." + enumName + "." + key);
            if (prefixIdx) {
              enumText = ++idx + ". " + enumText;
            }

            let item = {
              enumValue: v,
              enumKey: key,
              enumText: enumText,
            };

            if (ix > -1) {
              arr[ix] = item;
            } else {
              arr.push(item);
            }
          }
        }
      }
    }
    return arr;
  }

  /**
   * Lấy tham số trên query string
   */
  getUrlParams() {
    let search;
    if (window.location.hash) {
      search = window.location.hash.substr(1);
    } else {
      search = window.location.search;
    }
    const temp = new URLSearchParams(search);
    let result = {};
    for (var value of temp.keys()) {
      result[value] = temp.get(value);
    }

    return result;
  }

  /**
   * Đăng xuất khỏi ứng dụng
   */
  logoff() {
    //giải phóng tài nguyên
    let storeDebug = store;
    let fn = [ModuleContext, "logoff"].join("/");
    store.dispatch(fn);
    //TODO: Fix LeftMenu khi mà đăng xuất
    window.localStorage.removeItem("_jp_MerchantStatus");

    // Chuyển hướng về trang chính (đã cấu hình tự động chuyển hướng đến MISA ID)
    // window.location.href = "/";
  }

  downloadLink(link) {
    // location.href = link;
    let a = document.getElementById("adownload");
    a.href = link;
    a.click();
  }

  /**
   * Gán cookie
   */
  setCookie(name, value, hours) {
    var expires = "";
    if (hours) {
      var date = new Date();
      date.setTime(date.getTime() + hours * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  /**
   * Đọc cookie
   */
  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  /**
   * Xóa cookie
   */
  removeCookie(name) {
    document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }

  /**
   * Xử lý dữ liệu trả về từ server
   */
  processServerResponseData(data) {
    if (data) {
      const rg = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d/;
      for (let i in data) {
        if (data[i]) {
          if (typeof data[i] === "string" && i.indexOf("Date") > -1 && rg.test(data[i])) {
            data[i] = new Date(data[i]);
          } else if (typeof data[i] === "object" && Object.keys(data[i].length > 0)) {
            this.processServerResponseData(data[i]);
          }
        }
      }
    }
  }

  /**
   * Lấy text hiển thị của trường thông tin
   * @param {*} field : Tên trường
   * @param {*} namespace : mã để xem có custom lại không, nếu không thì lấy mặc định
   */
  getColumnText(field, namespace) {
    const localize = i18n.global,
      common = localize.messages.value[localize.locale.value]["i18nColumn"],
      custom = namespace ? common[namespace] : null;
    if (custom && custom.hasOwnProperty(field)) {
      return custom[field];
    }
    return common[field];
  }

  /**
   * Lấy text hiển thị của bảng
   * @param {*} table : Tên bảng
   * @param {*} namespace : mã để xem có custom lại không, nếu không thì lấy mặc định
   */
  getTableText(table, namespace) {
    const localize = i18n.global,
      common = localize.messages.value[localize.locale.value]["i18nTable"],
      custom = namespace ? common[namespace] : null;

    if (custom && custom.hasOwnProperty(table)) {
      return custom[table];
    }
    return common[table];
  }
  /**
   * Maping từ html element thành đối tượng vuejs để thao tác
   * @param {object} dom html dome element
   */
  mapDomToVue(dom) {
    return dom.__vue__;
  }

  /**
   * Chuyển tiếng việt có dấu thành không dấu
   * @author ĐVThi 09/03/2021
   */
  removeVietnameseTones(str) {
    if (str) {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
      str = str.replace(/Đ/g, "D");
      // Some system encode vietnamese combining accent as individual utf-8 characters
      // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
      // Remove extra spaces
      // Bỏ các khoảng trắng liền nhau
      str = str.replace(/ + /g, " ");
      str = str.trim();
      // Remove punctuations
      // Bỏ dấu câu, kí tự đặc biệt
      //str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g," ");
      return str;
    } else {
      return "";
    }
  }

  arrayMove(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  }

  buildFilterParam(filters) {
    let me = this,
      sFilter = "";
    if (filters && !(filters instanceof Array)) {
      filters = [filters];
    }

    let length = filters.length;

    if (length > 0) {
      let i,
        arrayFilters = [],
        sJoin = ",";

      for (i = 0; i < length; i++) {
        let filter = filters[i],
          sChildFilter = "",
          operandChild = "and";

        let filterChildren = [];
        let hasOrs = filter.Ors && Array.isArray(filter.Ors) && filter.Ors.length > 0;
        let hasAnds = filter.Ands && Array.isArray(filter.Ands) && filter.Ands.length > 0;
        if (hasOrs) {
          filterChildren = filter.Ors;
          operandChild = "or";
        } else if (hasAnds) {
          filterChildren = filter.Ands;
          operandChild = "and";
        }

        if (filterChildren instanceof Array && filterChildren.length > 0) {
          sChildFilter = me.buildFilterParam(filterChildren);
        }

        let s = '"' + filter.Field + '",' + (filter.Operator ? '"' + filter.Operator + '",' : ""),
          //Mặc định operand là `and`
          operand = '"and"';
        if (filter.Operand) {
          operand = `"${filter.Operand}"`;
        }

        s += me.nomalizeFilterValue(filter.Operator, filter.Value);
        //xử lý tình huống muôn filter = 0/false nhưng muốn lọc ra cả các giá trị null
        if (filter.NullToFail && (filter.Value === 0 || filter.Value === false)) {
          s += ",true";
        }

        s = "[" + s + "]";

        if (sChildFilter) {
          s = "[" + s + ',"' + operandChild + '",' + sChildFilter + "]";
        }

        if (i !== 0) {
          arrayFilters.add(operand);
        }
        arrayFilters.add(s);
      }

      sFilter = arrayFilters.join(sJoin);
    }
    if (length >= 1) {
      sFilter = "[" + sFilter + "]";
    }

    return sFilter;
  }

  nomalizeFilterValue(operator, value) {
    var ret = "";
    switch (operator) {
      case "in":
      case "notin":
        ret = JSON.stringify(value);
        break;
      default:
        if (typeof value === "number") {
          ret = value.toString();
        } else if (typeof value === "boolean") {
          ret = value;
        } else if (value instanceof Date) {
          if (value.getHours() === 0 && value.getMinutes() === 0 && value.getSeconds() === 0) {
            ret = ['"', moment(value).format("YYYY-MM-DD"), 'T00:00:00"'].join("");
          } else {
            ret = ['"', moment(value).format("YYYY-MM-DDTHH:mm:ss"), '"'].join("");
          }
        } else {
          ret = ['"', value, '"'].join("");
        }
    }

    return ret;
  }

  /**
   * Xử lý tham số trước khi gọi lên server load dữ liệu cho combobox
   */
  processComboboxParamRequest(param) {
    const me = this;
    for (let i in param) {
      let value = param[i];
      switch (i) {
        case "filter":
          //chuẩn hóa tham số filter
          if (Array.isArray(value) && value.length > 0) {
            value = me.buildFilterParam(value);
          } else {
            continue;
          }
          break;
      }
      param[i] = value;
    }
  }

  setLocalStorage(key, value) {
    localStorage.setItem(this.processLocalStorageKey(key), value);
  }

  getLocalStorage(key) {
    return localStorage.getItem(this.processLocalStorageKey(key));
  }

  removeLocalStorage(key) {
    localStorage.removeItem(this.processLocalStorageKey(key));
  }

  processLocalStorageKey(key) {
    return ["_jp", key].join("_");
  }

  getRole() {
    axios
      .get(`${window._apis.UserSystem}/roles`, {
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  checkFullMonth(fromDate, toDate) {
    let shortText = "",
      localize = i18n;
    if (fromDate && toDate) {
      if (fromDate.getDate() == 1) {
        let fromYear = fromDate.getFullYear(),
          fromMonth = fromDate.getMonth();
        let toYear = toDate.getFullYear(),
          toMonth = toDate.getMonth();
        let daysOfMonth = 32 - new Date(toYear, toMonth, 32).getDate();
        if (toDate && daysOfMonth == toDate.getDate()) {
          if (fromMonth == toMonth && fromYear == toYear) {
            shortText = localize.t("i18nReport.ReportTerm").format(fromMonth + 1, fromYear);
          } else if (fromMonth < toMonth && fromYear == toYear) {
            shortText = localize
              .t("i18nReport.ReportTermRange")
              .format(fromMonth + 1, toMonth + 1, fromYear);
          }
          return shortText;
        }
      }
    }
    return shortText;
  }

  helpAms(helpId) {
    return [window._external.amisAmsHelp, helpId].join("");
  }

  /**
   * Func bỏ dấu tiếng việt
   * @param {String} str
   * @author NCThanh1
   */
  removeUnicode(str) {
    let tmp = str;
    tmp = tmp.toLowerCase();
    tmp = tmp.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    tmp = tmp.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    tmp = tmp.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    tmp = tmp.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    tmp = tmp.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    tmp = tmp.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    tmp = tmp.replace(/đ/g, "d");
    tmp = tmp.replace(
      /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
      " ",
    );
    tmp = tmp.replace(/ + /g, " ");
    tmp = tmp.trim();
    return tmp;
  }

  /**
   * Load dữ liệu combobox
   */
  getCacheComboboxData(type, payload, loadPromise, loadScope) {
    let key = [type, JSON.stringify(payload)].join("_").toLowerCase(),
      cache = window._cboData[key];

    return new Promise((resolve) => {
      if (cache) {
        resolve(cache);
        return;
      }

      loadPromise.call(loadScope, payload).then((result) => {
        window._cboData[key] = result;
        resolve(result);
      });
    });
  }

  /**
   * Decode Token
   * @param {access Token} token
   * @returns
   */
  parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(""),
    );

    return JSON.parse(jsonPayload);
  }

  readGroup(group) {
    let readDigit = [
      " Không",
      " Một",
      " Hai",
      " Ba",
      " Bốn",
      " Năm",
      " Sáu",
      " Bảy",
      " Tám",
      " Chín",
    ];
    let temp = "";
    if (group == "000") return "";
    //read number hundreds
    temp = readDigit[parseInt(group.substring(0, 1))] + " Trăm";
    //read number tens
    if (group.substring(1, 2) == "0")
      if (group.substring(2, 3) == "0") return temp;
      else {
        temp += " Lẻ" + readDigit[parseInt(group.substring(2, 3))];
        return temp;
      }
    else temp += readDigit[parseInt(group.substring(1, 2))] + " Mươi";
    //read number
    if (group.substring(2, 3) == "5") temp += " Lăm";
    else if (group.substring(2, 3) != "0") temp += readDigit[parseInt(group.substring(2, 3))];
    return temp;
  }

  readMoney(value) {
    const me = this;
    if (value == null || value == "") return "";
    let temp = "";
    while (value.length < 18) {
      value = "0" + value;
    }
    let g1 = value.substring(0, 3);
    let g2 = value.substring(3, 6);
    let g3 = value.substring(6, 9);
    let g4 = value.substring(9, 12);
    let g5 = value.substring(12, 15);
    let g6 = value.substring(15, 18);

    //read group1 ---------------------
    if (g1 != "000") {
      temp = me.readGroup(g1);
      temp += " Triệu";
    }
    //read group2-----------------------
    if (g2 != "000") {
      temp += me.readGroup(g2);
      temp += " Nghìn";
    }
    //read group3 ---------------------
    if (g3 != "000") {
      temp += me.readGroup(g3);
      temp += " Tỷ";
    } else if (temp != "") {
      temp += " Tỷ";
    }

    //read group2-----------------------
    if (g4 != "000") {
      temp += me.readGroup(g4);
      temp += " Triệu";
    }
    //---------------------------------
    if (g5 != "000") {
      temp += me.readGroup(g5);
      temp += " Nghìn";
    }

    temp = temp + me.readGroup(g6);

    temp = temp.replaceAll("Một Mươi", "Mười");
    temp = temp.trim();
    temp = temp.replaceAll("Không Trăm", "");
    temp = temp.trim();
    temp = temp.replaceAll("Mười Không", "Mười");
    temp = temp.trim();
    temp = temp.replaceAll("Mươi Không", "Mươi");
    temp = temp.trim();
    if (temp.indexOf("Lẻ") == 0) temp = temp.substring(2);
    temp = temp.trim();
    temp = temp.replaceAll("Mươi Một", "Mươi Mốt");
    temp = temp.trim();

    return (
      "(" + temp.substring(0, 1).toUpperCase() + temp.substring(1).toLowerCase() + " đồng chẵn)"
    );
  }

  /**
   * Viết hoa chữ cái đầu tiên mỗi từ trong chuỗi
   * @param {*} str
   * @returns
   */
  capitalizeTheFirstWord(str) {
    if (!str) return "";
    var splitStr = str.split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(" ");
  }
  zip(a, ...allItems) {
    return a?.map((a, i) => {
      const res = [a];
      for (const arr of allItems) {
        res.push(arr[i]);
      }
      return res;
    });
  }
  calculateWER(reference, hypothesis) {
    const refTokens = reference.toLowerCase().split("");
    const hypTokens = hypothesis.toLowerCase().split("");
    const dp = Array(refTokens.length + 1)
      .fill(null)
      .map(() => Array(hypTokens.length + 1).fill(0));

    for (let i = 0; i <= refTokens.length; i++) {
      dp[i][0] = i;
    }
    for (let j = 0; j <= hypTokens.length; j++) {
      dp[0][j] = j;
    }
    for (let i = 1; i <= refTokens.length; i++) {
      for (let j = 1; j <= hypTokens.length; j++) {
        const cost = refTokens[i - 1] !== hypTokens[j - 1] ? 1 : 0;
        dp[i][j] = Math.min(
          dp[i - 1][j] + 1, // Deletion
          dp[i][j - 1] + 1, // Insertion
          dp[i - 1][j - 1] + cost, // Substitution
        );
      }
    }
    const editDistance = dp[refTokens.length][hypTokens.length];
    const S = editDistance;
    const D = refTokens.length - hypTokens.length;
    const I = hypTokens.length - refTokens.length;
    const N = refTokens.length;
    const WER = (S + D + I) / N;
    return WER;
  }
  /**
   * Hàm cắt ảnh
   * @param {*} inputFile InputElement
   * @param {*} coordinates Array: Tọa độ điểm cắt [to, left, witdh ,hight]
   * @param {*} callback
   * Example usage:
   * const inputFile = document.getElementById('inputFile'); // Replace 'inputFile' with the ID of your file input element
   * const coordinates = [10, 20, 150, 200]; // Example coordinates
   * cropImage(inputFile, coordinates, function (croppedImage) {
   *   if (croppedImage) {
   *     // Use the cropped image as needed (e.g., display it)
   *     const imgElement = document.createElement('img');
   *     imgElement.src = croppedImage;
   *     document.body.appendChild(imgElement);
   *   } else {
   *     console.log('No input file provided.');
   *   }
   * });
   * @returns
   */
  async cropImage(imageUrl, coordinates, callback, padding = 7) {
    if (coordinates?.length !== 4) {
      callback(null); // Return null if the coordinates array is invalid
      return;
    }

    const [imgWith, imgHeigt] = await this.getImageShape(imageUrl);
    const [left, top, width, height] = coordinates;
    padding = Math.ceil((width * padding) / 100);
    const img = new Image();
    img.crossOrigin = "anonymous"; // Allow cross-origin image access

    img.onload = function () {
      // Create a new canvas with the adjusted size
      const canvas = document.createElement("canvas");
      canvas.width = Math.min(width + padding * 2, imgWith);
      canvas.height = Math.min(height + padding * 2, imgHeigt);
      const ctx = canvas.getContext("2d");

      // Draw the image on the canvas with padding
      ctx.drawImage(
        img,
        Math.max(left - padding, 0),
        Math.max(top - padding, 0),
        canvas.width,
        canvas.height,
        0,
        0,
        canvas.width,
        canvas.height,
      );

      // Create a new image element for the cropped image
      const croppedImage = new Image();
      croppedImage.src = canvas.toDataURL();

      callback(croppedImage);
    };
    img.src = imageUrl;
  }
  /**
   * Giaiari mã base 64 sang File
   * @param {*} base64
   * @param {*} filename
   * @param {*} mimeType
   * @returns
   */
  base64ToFile(base64, filename = "image.png", mimeType = "image/png") {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: mimeType });
    const file = new File([blob], filename, { type: mimeType });

    return file;
  }
  /**
   * Lấy kích thước ảnh
   * @param {*} imageUrl
   * @returns
   */
  getImageShape(imageUrl) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = function () {
        resolve([img.width, img.height]);
      };
      img.src = imageUrl;
    });
  }

  safeParseJson(data) {
    if (!data) return {};
    if (typeof data === "string") {
      try {
        return JSON.parse(data);
      } catch (e) {
        console.warn("❌ Invalid JSON in PrivateSchoolForm.safeParse:", data);
        return {};
      }
    }
    if (typeof data === "object") {
      return data; // Đã là object rồi
    }
    return {};
  }
}
export default new CommonFunction();
